import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import apiClient from "@/lib/api/client.ts";

async function downloadFile(fileId: number): Promise<{ downloadUrl: string }> {
  return await apiClient
    .url(`/attachments/download/${fileId}`)
    .get()
    .json<{ downloadUrl: string }>();
}

type DownloadVariables = {
  fallbackUrl: string;
  fileId: number;
};

export function useDownloadAttachments(): UseMutationResult<
  string,
  Error,
  DownloadVariables,
  unknown
> {
  return useMutation<string, Error, DownloadVariables, unknown>({
    mutationFn: async ({ fileId }) => {
      const { downloadUrl } = await downloadFile(fileId);

      return downloadUrl;
    },
    onError: (err, variables) => {
      console.error("Failed to download", err);
      window.open(variables.fallbackUrl, "_blank");
    },
    onSuccess: (data) => {
      const link = document.createElement("a");

      link.href = data;
      document.body.append(link);
      link.click();
      link.remove();
    },
  });
}
